import { atom } from 'jotai';
import { ToastIconType } from '~/components/simple-toast/toast-icon';

type ToastAtomType = {
  time: number;
  content: string;
  iconStatus?: ToastIconType;
};

export const $ToastAtom = atom<ToastAtomType>({
  time: 0,
  content: '',
});
